export const isUrlAbsolute = (url?: string): boolean => url?.indexOf('://') > 0 || url?.indexOf('//') === 0;
